<template>
  <v-container class="forgot-password-container" data-testid="forgot-password">
    <v-row>
      <v-col cols="12" offset-md="3" md="6" offset-lg="4" lg="4">
        <router-link :to="'/'">
          <v-img
            class="home-logo"
            :src="require('@/assets/logo.png')"
            height="200px"
            contain
          />
        </router-link>
        <h1>ลืมรหัสผ่าน</h1>
        <v-form
          :disabled="isLoading"
          v-model="valid"
          :lazy-validation="false"
          @submit.prevent="submitForm"
        >
          <v-text-field
            label="Password"
            id="password"
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show = !show"
            :rules="[rules.required]"
            v-model="password"
          />
          <v-text-field
            label="Confirm Password"
            id="confirm-password"
            :type="showConfirm ? 'text' : 'password'"
            :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showConfirm = !showConfirm"
            :rules="[rules.required]"
            v-model="confirmPassword"
          />
          <v-btn
            id="forgot-password-button"
            outlined
            rounded
            large
            block
            type="submit"
            :disabled="isLoading || !valid || checkInput"
            >ยืนยัน</v-btn
          >
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Utils from "@/mixin";

import { SetRedirectURL } from "@/plugins/common";

export default {
  mixins: [Utils],
  async created() {
    await localStorage.removeItem("token");
    await this.checkHash();
  },
  computed: {
    checkInput() {
      const { confirmPassword, password } = this;
      return confirmPassword === password ? false : true;
    },
  },
  data: () => ({
    valid: false,
    show: false,
    showConfirm: false,
    confirmPassword: "",
    password: "",
    rules: {
      required: (value) => !!value || "กรุณากรอกข้อมูล",
    },
    token: "",
    query: {},
  }),
  methods: {
    async checkHash() {
      // replace url pathname
      const { origin, pathname } = window.location;
      const aLink = document.createElement("a");
      aLink.href = origin + pathname;
      const url = new URL(aLink);

      const redirect = SetRedirectURL(
        this.$route.hash,
        encodeURIComponent(this.$route.fullPath)
      );
      if (redirect.token) {
        this.token = redirect.token;
        this.query = {
          code: this.$route.query.code,
          ref: this.$route.query.ref,
        };
        await this.appAccess(this.token);
        // replace url pathname
        window.history.pushState({}, "", url);
      } else {
        window.location = redirect.url;
      }
    },
    async submitForm() {
      const formData = {
        confirmPassword: this.confirmPassword,
        newPassword: this.password,
        code: this.query?.code,
        ref: this.query?.ref,
      };
      this.resetPassword(formData);
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot-password-container {
  text-align: center;
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    height: 100%;
  }
  @media (max-width: 768px) {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
}
</style>